export const onCreateNewsCritics = (createNewsCritics, isReady) => {
    if (isReady) {
        createNewsCritics();
    }
};
const createNewsCritics = ({ addAvNirvana, addBluRay, addHidefDigest, addSingleSource, addWhySoBlu, avNirvanaReady, bluRayReady, hidefDigestReady, singleSourceReady, whySoBluReady }) => {
    onCreateNewsCritics(addAvNirvana, avNirvanaReady);
    onCreateNewsCritics(addBluRay, bluRayReady);
    onCreateNewsCritics(addHidefDigest, hidefDigestReady);
    onCreateNewsCritics(addSingleSource, singleSourceReady);
    onCreateNewsCritics(addWhySoBlu, whySoBluReady);
};
export default createNewsCritics;
